<template>
  <el-menu
    background-color="#F5F4F2"
    :default-active="
      store.state.login_type == 'mandate'
        ? '1'
        : store.state.login_type == 'administrator'
        ? '4'
        : '3'
    "
    class="el-menu-gkt"
  >
    <el-image
      id="menu-logo"
      class="no-select"
      :src="require('@/img/menu-header-image.png')"
    />

    <el-menu-item
      index="1"
      v-if="
        (store.state.login_type == 'mandate') |
          (store.state.login_type == 'provider')
      "
    >
      <div class="menu-btn no-select">
        <el-image
          class="menu-logo orange no-select"
          :src="require('@/img/drop.svg')"
        />
        <el-image
          class="menu-logo white no-select"
          :src="require('@/img/drop-white.svg')"
        />
      </div>
      <template #title>
        <router-link to="/cleaning">
          <span class="display2lineRouterLink" v-html="$t('cleaning')"></span>
        </router-link>
      </template>
    </el-menu-item>
    <el-menu-item index="2" v-if="store.state.login_type == 'mandate'">
      <div class="menu-btn no-select">
        <el-image
          class="menu-logo orange no-select"
          :src="require('@/img/tool.svg')"
        />
        <el-image
          class="menu-logo white no-select"
          :src="require('@/img/tool-white.svg')"
        />
      </div>
      <template #title>
        <router-link to="/provider">{{ $t("provider") }}</router-link>
      </template>
    </el-menu-item>
    <el-menu-item index="3" v-if="store.state.login_type != 'administrator'">
      <div class="menu-btn no-select">
        <el-image
          class="menu-logo orange no-select"
          :src="require('@/img/note.svg')"
        />
        <el-image
          class="menu-logo white no-select"
          :src="require('@/img/note-white.svg')"
        />
      </div>
      <template #title>
        <router-link to="/announcements">{{ $t("announcements") }}</router-link>
      </template>
    </el-menu-item>
    <el-menu-item index="4" v-if="store.state.login_type == 'administrator'">
      <div class="menu-btn no-select">
        <el-image
          class="menu-logo orange no-select"
          :src="require('@/img/note.svg')"
        />
        <el-image
          class="menu-logo white no-select"
          :src="require('@/img/note-white.svg')"
        />
      </div>
      <template #title>
        <router-link to="/users">{{ $t("users") }}</router-link>
      </template>
    </el-menu-item>
    <el-menu-item index="5" v-if="store.state.login_type == 'mandate'">
      <div class="menu-btn no-select">
        <el-image
          class="menu-logo orange no-select"
          :src="require('@/img/house.svg')"
        />
        <el-image
          class="menu-logo white no-select"
          :src="require('@/img/house-white.svg')"
        />
      </div>
      <template #title>
        <router-link to="/locations">{{ $t("locations") }}</router-link>
      </template>
    </el-menu-item>
    <el-menu-item
      index="6"
      v-if="
        store.state.noticesfield == true &&
          store.state.login_type != 'administrator'
      "
    >
      <div class="menu-btn no-select">
        <el-image
          class="menu-logo orange no-select"
          :src="require('@/img/note.svg')"
        />
        <el-image
          class="menu-logo white no-select"
          :src="require('@/img/note-white.svg')"
        />
      </div>
      <template #title>
        <router-link to="/notice"
          ><span
            class="display2lineRouterLink"
            v-html="$t('notices_nav')"
          ></span
        ></router-link>
      </template>
    </el-menu-item>
  </el-menu>
</template>

<style lang="scss">
li.el-menu-item {
  height: 75px;
  line-height: 75px;
  background-color: transparent !important;
  margin-bottom: 12px;

  @media screen and(max-width: 1500px) {
    padding: 0 !important;
  }

  .display2lineRouterLink {
    line-height: 1.5em;
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: pre-line;
  }

  &::before {
    display: block;
    position: absolute;
    left: 0;
    right: 48px;
    background-color: transparent;
    bottom: 0;
    content: "";
    height: 100%;
    border-top-right-radius: 21px;
    border-bottom-right-radius: 21px;
    z-index: 0;
    transition: background-color 0.25s ease-in-out;

    @media screen and(max-width: 1500px) {
      display: none;
    }
  }

  .menu-btn {
    display: inline-block;
    background-image: url("~@/img/menu-btn-bg.png");
    transition: background-image 0.25s ease-in-out;
    background-size: 80px 80px;
    width: 80px;
    height: 80px;
    background-repeat: no-repeat;
    display: inline-flex;
    justify-items: center;
    align-items: center;
    justify-content: center;
    align-content: center;
    z-index: 1;
    position: relative;

    div.el-image {
      display: inline-flex;

      &.white {
        display: none;
      }

      img {
        height: 30px;
        width: 25px;
      }
    }
  }

  a {
    color: #5a5958;
    position: relative;
    z-index: 1;
    text-transform: uppercase;
    text-decoration: none;
    position: absolute;
    display: flex;
    width: calc(100% - 108px);
    height: 100%;
    left: 0;
    top: 0;
    padding-left: 108px;
    transition: color 0.25s ease-in-out;
    outline: none !important;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    @media screen and(max-width: 1500px) {
      text-indent: -999999px;
    }
  }

  &:hover,
  &:focus,
  &.is-active {
    &::before {
      background-color: $gkt-orange;
      transition: background-color 0.25s ease-in-out;
    }

    a {
      color: #fff;
      transition: color 0.25s ease-in-out;
    }

    .menu-btn {
      background-image: url("~@/img/menu-btn-bg-active.png");
      transition: background-image 0.25s ease-in-out;

      div.el-image {
        &.orange {
          display: none;
        }

        &.white {
          display: flex;
        }
      }
    }
  }
}

div.el-image {
  display: block;

  #menu-logo {
    max-width: 218px;
    margin: 0 auto;
    margin-bottom: 128px;
    margin-top: 24px;
    display: block !important;

    @media screen and(max-width: 1500px) {
      max-width: 70px;
    }
  }
}
</style>

<script>
import { provide } from "vue";
import store from "@/store";

export default {
  name: "Nav",
  setup() {
    provide("store", store);
  },
  data: () => ({
    store
  }),
  methods: {}
};
</script>
